export default {
  "session.securityLogout": "Security logout!",
  "session.differentNewPassword": "New password is the same as existing!",
  "session.differentPassword": "New passwords do not match!",
  "session.authorizationError": "You are not allowed to do that operation!",
  "messages.error": "An error occured while sending data!",
  "messages.serverError": "Server not available. Please log in later.",
  "messages.notFound": "Sorry, page you are searched does not exist.",
  "messages.yes": "Yes",
  "messages.no": "No",
  "messages.back": "Return",
  "messages.close": "Close",
  "messages.filtering": "Filter",
  "messages.clearForm": "Clear form",
  "messages.list": "List {header}",
  "messages.successSave": "Saved successfully",
  "messages.processingError": "An error occured while processing",
  "messages.error500": "Sorry, an error occured. Please try it again.",
  "messages.retryLoading": "Retry loading",
  "messages.print": "Print",
  "messages.printOffer": "Print offer",
  "messages.delete": "Delete",
  "messages.here": "here",
  "messages.save": "Save",
  "messages.insert": "Insert",
  "messages.cancel": "Cancel",
  "messages.showAll": "Expand all",
  "messages.hideAll": "Collapse all",
  "messages.continue": "Continue",
  "messages.calculate": "Calculate",
  "messages.warning": "Warning",
  "messages.confirm": "Confirm",
  "messages.formLoadError": "An error occured while loading the form",
  "messages.logOut": "Log out",
  "messages.loggedOut": "Logged out!",
  "messages.chooseDate": "Select a date",
  "messages.validEmail": "Please enter a valid email!",
  "messages.validVariableSymbol":
    "The variable symbol must contain only numbers and have a maximum length of 10!",
  "messages.validUnCode":
    "UN number must containt only numbers and have a length of 4!",
  "messages.range": "Exceeded permitted range of values from {min} to {max}!",
  "messages.lastWeek": "Last week",
  "messages.lastMonth": "Last month",
  "messages.loading": "Loading",
  "messages.loadAgain": "Reload",
  "messages.loadError": "An error occurred while loading the data",
  "messages.loadErrorEntity": "An error occurred while loading the {what}",
  "messages.errorTitle": "The failure was caused by the following error:",
  "messages.unknownError": "unknown error",
  "messages.saveFail": "Saving failed",
  "messages.saveFailBut":
    "Saved successfully, but the {item} does not have all the required parameters filled in!",
  "messages.deselectAll": "Deselect all rows",
  "messages.selectAll": "Select all rows",
  "messages.allCorect": "All entered values are correct.",
  "messages.someIncorrect":
    "This section contains missing or incorrectly entered values!",
  "messages.filter": "Filter",
  "messages.editItem": "edit this row",
  "messages.dropItem": "delete this row",
  "messages.drop.question": "Are you sure you want to delete this record?",
  "messages.noRoles": "Access denied",
  "messages.noRoles.info": "You do not have sufficient permissions to access.",
  "messages.connection.error":
    "Cannot connect to the server, the web application will not work properly, please try again later. Thank you.",
  "messages.validAccount": "Enter valid zAccoount!",
  "messages.search": "Search",
  "messages.input.required": "This field is mandatory!",
  "messages.maxLength": "The maximum length allowed is {count} characters.",
  clientUser: "Client/user information",
  "clientUser.info":
    "View information about client users and available user clients.",
  "clientUser.user": "Clients of the user",
  "clientUser.client": "Users of the client",
  "clientUser.accountOrName": "z-account/name of the client",
  "clientUser.username": "username",
  "clientUser.client.name": "Name",
  "clientUser.client.companyId": "Company ID",
  "clientUser.client.account": "z-account",
  "clientUser.client.evoCode": "EVO code",
  "crud.edit": "{what} successfully edited.",
  "crud.editError": "An error occurred while editing the {whatError}!.",
  "crud.delete": "{what} deleted successfully.",
  "crud.deleteError": "An error occurred while deleting the {whatError}!",
  "footer.fraud": "Fraud information",
  "footer.terms": "Terms and conditions",
  "footer.legal": "Legal notice",
  "footer.privacy": "Privacy Notice",
  "footer.conflict": "Conflict solving",
  "footer.access": "Accessibility",
  "footer.follow": "Follow us on",
  "footer.version": "web application version {version}",
  "footer.rights": "{year} © DHL Freight CZ, s.r.o. All rights reserved.",
  "header.home": "Home",
  "header.contact": "Contact",
  "header.news": "News",
  "header.services": "Services",
  "header.backToMain": "Back to the home page",
  "menu.newConsignment": "New shipment",
  "menu.newConsignment.new": "Create",
  "menu.newConsignment.import": "Data import",
  "menu.newConsignment.template": "From the template",
  "menu.consignmentList": "Shipment overview",
  "menu.consignmentList.notSent": "Not sent to DHL",
  "menu.consignmentList.sent": "Sent to DHL",
  "menu.tracking": "Shipment tracking",
  "menu.customers": "Customer list",
  "menu.calculator": "Price calculation",
  "menu.contracts": "Terms and Conditions and Contracts",
  "menu.invoices": "Invoice list",
  "menu.setting": "Settings",
  "menu.setting.users": "User maintenance",
  "menu.setting.oneTimeLogin": "One time login",
  "menu.setting.changePassword": "Password change",
  "menu.notifications": "Notifications",
  "menu.documents": "Documents",
  "menu.documents.new": "New document",
  language: "Language",
  "language.errorName": "a language",
  user: "User",
  "user.whom": "users",
  "user.list": "List of users",
  "user.new": "New user",
  "user.edit": "Edit user",
  "user.add": "Add user",
  "user.add.title": "Add an existing user",
  "user.add.info":
    "Adding an existing user to this company. This user will have access to information according to their current role. If you wish to remove access from a user, you can do so by clicking the icon in the Account State column on the row for that user.",
  "user.changePassword": "Change password",
  "user.currentPassword": "Current password",
  "user.newPassword": "New password",
  "user.confirmNewPassword": "Confirm a new password",
  "user.emptyCurrentPassword": "Enter your current password",
  "user.emptyNewPassword": "Enter a new password",
  "user.emptyConfirmNewPassword": "Enter a new password again",
  "user.savePassword": "Change password",
  "user.resetPassword": "Reset password",
  "user.resetingPassword": "Password is being reset",
  "user.signOutByPassword":
    "You will be logged out for security reasons due to the password change.",
  "user.yourPassword": "Your new password is ",
  "user.usersPassword": "{username}'s new password is ",
  "user.passwordQuestion":
    "Would you like to send a new password to {username}'s email (email address {email}) or view it here?",
  "user.sendToMail": "Send to e-mail",
  "user.showHere": "Show here",
  "user.createNew": "Creating a new user",
  "user.save": "Save user",
  "user.saved": "User saved successfully",
  "user.saveError": "An error occurred while saving the user",
  "user.usedUsername": "User name already exists. Please choose another.",
  "user.freeUsername": "User name is free to use.",
  "user.errorName": "the user",
  "user.expiredPassword": "Your password expired, please change it.",
  "user.successfulLogin": "Login successfull",
  "user.serverError": "Server unavailable, please try logging in later!",
  "user.emptyFirstName": "Enter name!",
  "user.emptyLastName": "Enter surname!",
  "user.emptyEmail": "Enter e-mail!",
  "user.emptyUserName": "Enter user name!",
  "user.firstname": "Name",
  "user.lastname": "Surname",
  "user.username": "User name",
  "user.userrole": "User role",
  "user.note": "Internal note",
  "user.email": "E-mail",
  "user.admin": "Administrator",
  "user.admin.yes": "User has administrator rights",
  "user.admin.no": "User without administrator rights",
  "user.blocked": "Account state",
  "user.lastLogin": "Date of last log in",
  "user.passwordChange": "Password change date",
  "user.passwordValidity": "Password expiration",
  "user.generatingPassword": "generating of new password",
  "user.noUsers": "this client has no users",
  "user.activedAccount": "This user account is active{suffix}.",
  "user.blockedAccount": "The user account is blocked{suffix}.",
  "user.enableAccount": ", click to unblock it",
  "user.disableAccount": ", click to block it",
  "user.signIn.message":
    "Web application for DHL customers designed for entering and managing orders.",
  "user.signIn.contact":
    "In case of problems contact our Customer Service on +420 239 018 222.",
  "user.signIn.username": "user name",
  "user.signIn.password": "password",
  "user.signIn.emptyUserName": "Please fill in your user name",
  "user.signIn.emptyPassword": "Please fill your password",
  "user.signIn.signIn": "Log in",
  "user.register": "New registration",
  "user.register.title": "You will be redirected to the e-registration website",
  "user.client.choose": "Select the customer you want to work at",
  "user.client.loadError": "An error occurred while loading customers!",
  "user.client.info": "enter z-account or customer name",
  "user.company": "Your company",
  "user.noClients": "the user does not have an assigned client",
  "user.menu": "User menu",
  "user.cs": "DHL Customer service",
  customer: "Customer",
  "customer.genitiv": "the customer",
  "customer.genitivMultiple": "the customers",
  "customer.multiple": "Customers",
  "customer.errorName": "the customer",
  "customer.edit": "Customer editing",
  "customer.edit.try": "Customer can no longer be edited!",
  "customer.import": "Import of customers",
  "customer.export": "Export of customers",
  "customer.exportWhom": "of the customers",
  "customer.list": "List of customers",
  "customer.add": "New customer",
  "customer.save": "Save customer",
  "customer.new": "Create a new customer based on this",
  "customer.noCustomers": "no specified customers",
  "customer.saveSuccess": "Customer saved successfully.",
  "customer.saveError": "An error occurred while saving the customer!",
  "customer.bulkDelete": "bulk deletion of customers",
  address: "Address",
  "address.errorName": "the address",
  "address.loadError": "An error occured while loading addresses!",
  "address.search": "Address search",
  "address.search.all": "all addresses",
  "address.search.pickup": "pick up only",
  "address.search.delivery": "delivery only",
  "address.searchInfo": "enter name, street, city, contact",
  "address.searchError":
    "Chosen address cannot be used, because address country is invalid for chosen product!",
  "address.name": "Party name",
  "address.emptyName": "Please enter name!",
  "address.subname": "Party name 2",
  "address.subnameAlter": "Party name 2",
  "address.street": "Street",
  "address.emptyStreet": "Please enter street name!",
  "address.streetNumber": "Street number",
  "address.emptyStreetNumber": "Please enter street number!",
  "address.localDestination": "Delivery place",
  "address.localDestinationInfo":
    "address specification (hall number, premises, warehouse)",
  "address.city": "City (locality)",
  "address.emptyCity": "Please enter a city!",
  "address.zipCode": "Postal code",
  "address.emptyZipCode": "Please enter a postal code!",
  "address.country": "Country",
  "address.emptyCountry": "Please select a country!",
  "address.contactPerson": "Contact person",
  "address.emptyContactPerson": "Please enter a contact name!",
  "address.vat": "VAT",
  "address.emptyVat": "Please enter a VAT!",
  "address.contactPhone": "Phone number",
  "address.emptyContactPhone": "Please enter a telephone number!",
  "address.contactEmail": "E-mail",
  "address.contactEmail.info":
    "It is possible to enter multiple email addresses separated by semicolon, with a total length of 128 characters.",
  "address.insertionDate": "Creating a customer",
  "address.changeDate": "Edit",
  "address.emptyPreselection": "Please select a prefix!",
  "address.saveAsCustomer": "Save as customer",
  "address.validation.zipCode.five":
    "Enter the postal code in five-digit format",
  "address.validation.zipCode.fiveCountry":
    "Enter the postal code in five-digit format with country code prefix (XX-)",
  "address.validation.zipCode.four":
    "Enter the postal code in four-digit format",
  "address.validation.zipCode.fourCountry":
    "Enter the postal code in four-digit format with country code prefix (XX-)",
  "address.validation.zipCode.poland":
    "Enter the postal code in correct format (XX-XXX)",
  "address.validation.zipCode.gbAndDe":
    "Enter the postal code in correct format",
  "address.validation.zipCode.alphanumeric":
    "Enter the postal code in alphanumeric format!",
  "address.validation.zipCode.others":
    "Enter the postal code in correct format for the selected country",
  "address.validation.phone.eight": "Enter the phone number of 8 digits!",
  "address.validation.phone.nineTen":
    "Enter the phone number of 9 or 10 digits!",
  "address.validation.phone.nine":
    "Enter the phone number in nine-digit format!",
  "address.validation.phone.ten": "Enter the phone number of 10 digits!",
  "address.validation.phone.eleven":
    "Enter the phone number of 10 or 11 digits!",
  "address.validation.phone.tenMore":
    "Enter the phone number of 10, 11, 12, 13, 14 digits!",
  "address.validation.phone.others":
    "Enter the phone number in the correct format for the selected country!",
  "address.import.dataFormat": "Description of the customer's data format",
  "address.import.info":
    "All attributes are subject to the same restrictions as when creating a policy using a web form. Attributes are optional, except for exceptions.",
  "address.import.name": "customer name",
  "address.import.subname": "customer party name 2",
  "address.import.street": "customer street name",
  "address.import.streetNumber": "customer street number/house number",
  "address.import.localDestination":
    "customer local destination (address specification)",
  "address.import.city": "customer's city (locality)",
  "address.import.zipCode":
    "customer postal code; format according to the selected country of the customer (internal spaces will be deleted)",
  "address.import.country":
    "customer country; in two-digit (ISO 3166-1 Alpha-2) or three-digit format (ISO 3166-1 Alpha-3)",
  "address.import.contactPerson": "customer contact person",
  "address.import.contactPhone":
    "customer telephone number; valid format according to the given prefix, in case the prefix is not entered, the Czech (+420) is added; the prefix can be entered in the format + XX or 00XX or XX",
  "address.import.contactEmail": "customer email; valid email format required",
  "address.self.pickup": "pick up",
  "address.self.delivery": "delivery",
  "address.self.type": "Self {type} at terminal",
  "address.self.depot": "Terminal",
  "address.self.emptyDepot": "Please select a DHL terminal for self {type}!",
  "address.self.error": "An error occurred while loading the terminals!",
  calculator: "Price calculator",
  "calculator.warning":
    "Price does not include Crisis Fuel Surcharge. Please contact DHL Freight CZ Customer service on +420 239 018 222 or DHLFreight.cz@dhl.com.",
  "calculator.noProducts": "You have no enabled products.",
  "calculator.info":
    "We are sorry, but the price calculator is only available for domestic (CZ) products.",
  "calculator.priceWithoutVat": "{currency} without VAT",
  "calculator.error": "An error occurred while calculating the price",
  "calculator.checkValues": "Please check the entered values",
  "calculator.priceItems": "Freight costs incl. tolls and fuel surcharge",
  "calculator.order": "Order shipping",
  "calculator.emptyValues":
    "Required fields are required and then click on Calculate button",
  "calculator.address.warning": "The price does not include customs fees.",
  "calculator.pickupZip": "Postal code of loading",
  "calculator.emptyPickupZip": "Please enter the postal code of loading!",
  "calculator.deliveryZip": "Postal code of unloading",
  "calculator.emptyDeliveryZip": "Please enter the postal code of unloading!",
  "calculator.pickupCountry": "Country of loading",
  "calculator.emptyPickupCountry": "Please choose country of loading",
  "calculator.deliveryCountry": "Country of unloading",
  "calculator.emptyDeliveryCountry": "Please choose country of unloading",
  "calculator.addColli": "Add shipment item",
  "calculator.insuranceInfo": "Add value of the goods",
  "calculator.height": "Height",
  "calculator.width": "Width",
  "calculator.length": "Length",
  "calculator.weight": "Weight",
  "calculator.price": "Price",
  "calculator.price.total": "Total price is {price} {currency}",
  "calculator.price.unknown":
    "There is no price list defined for a shipment with these parameters.",
  "calculator.noPrice": "price is unknown",
  "calculator.price.card":
    "(in case of payment by card, the Card fee of {price} is charged instead of Cash on delivery)",
  "calculator.price.B2OC": "Freight costs",
  "calculator.price.COD": "Cash on delivery",
  "calculator.price.FUEL": "Fuel surcharge",
  "calculator.price.TOLL": "Tolls",
  "calculator.price.EB": "P-EUR to return",
  "calculator.price.ADR": "ADR",
  "calculator.price.INSR": "Insurance",
  "calculator.price.OGB": "Carry to the floor",
  "calculator.price.FH": "Removal of an old device (appliance)",
  "calculator.price.CARD": "Card pay",
  "calculator.price.B2C": "B2C",
  "calculator.price.PSS": "Peak season",
  "calculator.price.EXTRA": "Extra",
  "calculator.price.ES": "Energy surcharge",
  "calculator.price.PS": "Priority surcharge",
  "calculator.price.DDP": "Delivery term DDP",
  "calculator.price.CSS": "customs services",
  "calculator.price.DOF": "Documentation Fee",
  "calculator.price.TSB": "Time slot booking",
  "calculator.price.GG1": "GoGreen Plus Service Charge",
  "calculator.price.GG2": "GoGreen Plus Base",
  "calculator.price.GG3": "GoGreen Plus Smart",
  "calculator.price.GG4": "GoGreen Plus Premium",
  "calculator.price.WD1": "Wrong data",
  consignment: "Shipment",
  "consignment.edit": "Shipment editing",
  "consignment.detail": "Shipment detail",
  "consignment.new": "New shipment",
  "consignment.genitiv": "the shipment",
  "consignment.whom": "the shipment",
  "consignment.genitivMultiple": "the shipments",
  "consignment.noConsignments": "no shipments",
  "consignment.unsent": "An unsent shipment",
  "consignment.saveWithValidation": "Save {saveWhat} with validation form",
  "consignment.errorName": "the shipment",
  "consignment.processError": "An error occured while processing the shipment",
  "consignment.processErrorOnServer":
    "An error on server occured while processing the shipment",
  "consignment.tracking": "Track&Trace",
  "consignment.track": "Track&Trace",
  "consignment.sent": "Shipments sent to DHL",
  "consignment.notSent": "Shipments in progress and unsent shipments",
  "consignment.dropConsignments": "Deleting",
  "consignment.dropConsignments.title": "bulk deletion of shipments",
  "consignment.dropConsignments.noConsignments":
    "No {entity} marked for deleting. Please mark some.",
  "consignment.dropConsignments.drop": "Delete shipments",
  "consignment.dropConsignments.end": "click to delete selected shipments",
  "consignment.exportConsignments": "Export",
  "consignment.exportConsignments.title": "export consignments to the excel",
  "consignment.exportConsignments.noConsignments":
    "No shipments marked for export. Please mark some.",
  "consignment.sendConsignments": "Send to DHL",
  "consignment.sendConsignmentsTitle": "Sends valid shipments to DHL",
  "consignment.printTitle": "Dispays the print menu of shipments",
  "consignment.noCollis": "Shipment has to contain 1 colli at least",
  "consignment.overWeight":
    "Total shipment weight is higher than maximum allowed",
  "consignment.overCalculatedWeight":
    "Total shipment calculated weight is higher than maximum allowed",
  "consignment.overVolume":
    "Total shipment volume is higher than maximum allowed",
  "consignment.overLoadingMeters":
    "Total loading meters are higher than maximum allowed!",
  "consignment.overNotStackable":
    "If the shipment is ADR, it must contain at least one non-replaceable piece!",
  "consignment.overCollis":
    "Total number of colli is higher than maximum allowed",
  "consignment.noWrapping":
    "Some shipment colli does not have valid type of packaging! Please check the individual collis.",
  "consignment.noDescription":
    "Some shipment colli does not have valid type of goods! Please check the individual collis.",
  "consignment.badColliDimension":
    "Some shipment colli does not have valid dimensions or weight! Please check the individual collis.",
  "consignment.product": "Product",
  "consignment.unknownProduct":
    "An automatic product change has taken place! Please check that properties of all addresses are correct. You no longer have the previously selected product enabled.",
  "consignment.state": "State",
  "consignment.code": "Shipment number",
  "consignment.reference": "Customer Reference",
  "consignment.externalCode": "External shipment number",
  "consignment.insertionDateTime": "Open date",
  "consignment.customerReference": "Reference",
  "consignment.pickup": "Pick up address",
  "consignment.delivery": "Delivery address",
  "consignment.invoice": "Invoicing address",
  "consignment.collis": "Loading units",
  "consignment.countOfCollis": "Number of colli",
  "consignment.type": "Type",
  "consignment.cashOnDelivery": "Cash On Delivery (C.O.D.)",
  "consignment.insurance": "Insurance",
  "consignment.insurance.recommendation":
    "You have exceeded the limit of automatic supplementary insurance ({price} {currency}). We recommend that you add insurance to your shipment!\nFor more information, please contact the Customer Service Centre at DHLFreight.cz@dhl.com or call +420 239 018 222.",
  "consignment.insurance.overPrice":
    "Your shipment exceeds the permitted value limit for the product. To place an order, please contact the Customer Service Centre at DHLFreight.cz@dhl.com or call +420 239 018 222.\n(Up to {limitPrice} {currency} is automatically insured. For amounts between {limitPrice} and {maxPrice} {currency}, we recommend additional insurance.)",
  "consignment.insurance.overPrice.error": "Maximum {price} exceeded",
  "consignment.status": "Status",
  "consignment.lastTrackMessage": "Shipment status",
  "consignment.sentDateTime": "Data sending",
  "consignment.sentByUser": "Sent by user",
  "consignment.createDate": "Open date",
  "consignment.createdByDhl": "Shipment was created by DHL employee.",
  "consignment.changedByDhl": "Shipment was edit by DHL employee.",
  "consignment.sentByDhl": "Shipment was sent to DHL by DHL employee.",
  "consignment.freapi": "Shipment was sent to DHL via FREAPI.",
  "consignment.variableSymbol": "C. O. D. variable symbol",
  "consignment.notPrintedLabel": "Only shipments without a printed label",
  "consignment.sentDate": "Sending a shipment",
  "consignment.codAmount": "C.O.D. amount",
  "consignment.insurance.withPrice":
    "Shipment has active Additional insurance for the value {price} {currency}; insurance fee is {insurancePrice} {insuranceCurrency}",
  "consignment.insurance.noPrice":
    "Additional insurance is active, but value of the goods is missing",
  "consignment.insurance.noInsurance": "No Additional insurance required",
  "consignment.colli.barcodeWarning":
    "Are you sure you want to enter the item number manually? You must have a numerical series and enter a non-duplicate number.",
  "consignment.colli.edit": "Item editing",
  "consignment.colli.add": "Entering a new item",
  "consignment.colli.copy": "Make a copy of the item",
  "consignment.colli.adding": "Adding a new item",
  "consignment.colli.noCollis": "No items entered",
  "consignment.colli.biggerThan0": "Value must be greater than 0!",
  "consignment.colli.lowerThanMax": "Maximum value {max} exceeded!",
  "consignment.colli.invalidValue": "invalid value",
  "consignment.colli.count": "Number of colli",
  "consignment.colli.notStackableCount": "Number not stackable colli",
  "consignment.colli.volume": "Volume [m³]",
  "consignment.colli.emptyCount": "Please enter the number of collis!",
  "consignment.colli.wrapping": "Type of packaging",
  "consignment.colli.wrapping.info":
    "Limitation of packaging types, click to see more.",
  "consignment.colli.wrapping.warn":
    "The selected product contains packaging material restrictions. The number on the right indicates the maximum number of items with the given packaging, the number in brackets is the current number.",
  "consignment.colli.wrapping.unlimited": "unlimited",
  "consignment.colli.wrapping.error":
    "The specified items do not meet the conditions of the selected product! Find more info <a>here</a>.",
  "consignment.colli.wrapping.errorShort":
    "The specified items do not meet the conditions of the selected product!",
  "consignment.colli.emptyWrapping": "Please select the type of packaging!",
  "consignment.colli.height": "Height [cm/pc]",
  "consignment.colli.emptyHeight": "Please enter the height!",
  "consignment.colli.overHeight": "Max size {max} cm exceeded!",
  "consignment.colli.width": "Width [cm/pc]",
  "consignment.colli.emptyWidth": "Please enter the width!",
  "consignment.colli.overWidth": "Max size {max} cm exceeded!",
  "consignment.colli.length": "Length [cm/pc]",
  "consignment.colli.emptyLength": "Please enter the length!",
  "consignment.colli.overLength": "Max size {max} cm exceeded!",
  "consignment.colli.weight": "Weight [kg]",
  "consignment.colli.emptyWeight": "Please enter the weight!",
  "consignment.colli.overWeight": "Maximum weight {max} kg exceeded!",
  "consignment.colli.overCalculatedWeight":
    "Maximum calculated weight {max} kg exceeded!",
  "consignment.colli.weightType1": "Weight of 1 item",
  "consignment.colli.weightTypeAll": "Weight of all items",
  "consignment.colli.weightTypeAllInfo":
    "the weight will be calculated proportionally to the individual items",
  "consignment.colli.overLoadingMeters":
    "Maximum loading meters {max} LDM exceeded!",
  "consignment.colli.description": "Type of goods",
  "consignment.colli.emptyDescription": "Please enter the type of goods!",
  "consignment.colli.manualBarcode": "Enter the item number manually",
  "consignment.colli.barcode": "Item number",
  "consignment.colli.invalidBarcode":
    "Enter the numer of item in correct form!",
  "consignment.colli.dimensions": "Item size [cm]",
  "consignment.colli.barcodeWillBeGenerated":
    "will be automatically generated after sending to DHL",
  "consignment.colli.stackable": "Stackable",
  "consignment.colli.stackable.yes": "Item is stackable",
  "consignment.colli.stackable.no": "Item is not stackable",
  "consignment.colli.stackable.warning":
    "Please determine which of the items is the ADR by unclick stackable flag.",
  "consignment.colli.loadingMeters": "Loading meters (LDM)",
  "consignment.colli.emptyLoadingMeters": "Please enter the loading meters!",
  "consignment.colli.calculatedWeight": "Calculated weight [kg]",
  "consignment.template.new": "New template",
  "consignment.template.edit": "Template editing",
  "consignment.template.name": "Template",
  "consignment.template.list": "Shipment templates",
  "consignment.template.what": "consignment templates",
  "consignment.template.errorName": "the template",
  "consignment.template.whom": "the template",
  "consignment.template.insertionDateTime": "Creation date",
  "consignment.template.templateName": "Template name",
  "consignment.template.creator": "Template creator",
  "consignment.template.noTemplates": "No shipments to print",
  "consignment.template.createNewFromOld":
    "create a new shipment based on this template",
  "consignment.template.createNew": "Create new template",
  "consignment.template.export": "Export",
  "consignment.template.export.title":
    "Export of templates for subsequent import into WA",
  "consignment.template.import": "Import",
  "consignment.template.import.title":
    "Import templates in format from Template Export",
  "consignment.template.import.error":
    "An error occurred while loading the shipment templates, please try again.",
  "consignment.saveAsTemplate": "Save shipment as template",
  "consignment.saveAsTemplateInfo":
    "New shipments can be created based on template data. When saving the template, new shipment will not be created in the same time. ",
  "consignment.templateName": "Enter template name",
  "consignment.emptyTemplateName": "Template name",
  "consignment.unknown": "Unknown shipment",
  "consignment.loadError": "An error occured while loading data",
  "consignment.edit.try": "Shipment can no longer be edited!",
  "consignment.send.price": "Current shipping prices for outgoing shipments",
  "consignment.send.question":
    "Do you really want to send marked shipments to DHL? If shipments are sent, it will no longer be possible to change anything.",
  "consignment.send.noConsignments":
    "No shipments marked for sending. Please mark some. ",
  "consignment.send.error": "An error occured while sending shipments.",
  "consignment.send.withRef": "Shipment ref. {reference}",
  "consignment.send.withoutRef": "Shipment without customer reference",
  "consignment.send.sendSuccess": "Export was successful",
  "consignment.send.sendError": "An error occured during the export",
  "consignment.send.resultTitle": "Result of data sending",
  "consignment.send.countOfValid": "Number of successfully sent shipments",
  "consignment.send.countOfInvalid": "Number of failed shipments",
  "consignment.print.noConsignments":
    "No shipments marked for printing. Please mark some.",
  "consignment.print.loadError":
    "An error occured while loading shipments. Please try again.",
  "consignment.print.labelLoadError":
    "An unexpected error occurred while retrieving labels.",
  "consignment.print.label": "Shipment label",
  "consignment.print.zplLabel": "Print label format ZPL (label printer)",
  "consignment.print.pdfLabel":
    "Print label format 4x6.5 - 1 label (label printer, pdf)",
  "consignment.print.label3":
    "Print label format A4 - 3 labels (normal printer)",
  "consignment.print.label4":
    "Print label format A4 - 4 labels (normal printer)",
  "consignment.print.consignentList": "List of shipments",
  "consignment.print.euroLine": "EuroLine",
  "consignment.print.euroLineCmr": "CMR",
  "consignment.print.euroLineLimitation":
    "Only for consignments with ELI or ELD product",
  "consignment.print.printConsignentList": "Print of shipment list",
  "consignment.print.labelPosition": "Choose position of the first label",
  "consignment.list.findInUnsend": "You can find it in unsent shipments",
  "consignment.list.showHistory": "View detailed shipment history",
  "consignment.list.hideHistory": "Hide detailed history",
  "consignment.list.copyTitle":
    "Shipment is a copy of another shipment. Before sending to DHL,  it has to be edit and save.",
  "consignment.list.valid": "Shipment is valid",
  "consignment.list.invalid":
    "Shipment contains incorrect or incomplete information",
  "consignment.list.footer.canBeSend": "Shipments can be sent to DHL",
  "consignment.list.footer.countOfValid": "Number of valid shipments",
  "consignment.list.footer.cannotBeSend":
    "Shipments cannot be sent to DHL. Please fill in obligatory attributes.",
  "consignment.list.footer.countOfInvalid": "Number of invalid shipments",
  "consignment.pod": "POD of consignment",
  "consignment.pod.empty": "POD is not available yet",
  "consignment.pod.show": "Click to view POD of shipment",
  "consignment.copy": "Shipment copy",
  "consignment.copy.copy": "Shipment copy",
  "consignment.copy.copying": "Copying shipment",
  "consignment.copy.success": "Shipment copied successfully",
  "consignment.copy.error": "An error occured while copying",
  "consignment.return": "Create return shipent",
  "consignment.return.create": "Return shipment",
  "consignment.return.creating": "Return shipment is being created",
  "consignment.return.success": "Return shipment created successfully",
  "consignment.return.error": "An error occured while creating",
  "consignment.cancel": "Cancel shipment",
  "consignment.cancelled": "Cancelled",
  "consignment.cancel.info": "Sends a cancellation request to DHL",
  "consignment.cancel.info.not": "Shipment cannot be cancelled.",
  "consignment.cancel.question":
    "Are you sure you want to cancel this shipment?",
  "consignment.cancel.success": "Shipment was successfully cancelled.",
  "consignment.cancel.done": "Shipment has already been cancelled.",
  "consignment.state.pickup":
    "Shipment is waiting to be picked up by consignor",
  "consignment.state.delivery": "Shipment is on the way to consignee",
  "consignment.state.delivered": "Shipment delivered successfully",
  "consignment.state.cancelled": "Shipment was cancelled by customer",
  "consignment.state.cancelled.user": "Cancelled by {first} {last}.",
  "consignment.state.return": "Shipment not delivered",
  "consignment.import.dataFormat": "Description of the shipment data format",
  "consignment.import.dataFormat.attributes":
    "All attributes are subject to the same limitation as when creating the shipment using web form. Attributes are not obligatory, excluding some exceptions. ",
  "consignment.import.dataFormat.countries":
    "Countries in addresses can be selected according to the current offer with respect to the selected product. For domestic products (ECD_B2B, ECD_B2C, ELD and ERD) only CZ is possible. The set of countries for ECI, ECI_B2C, ERI a ELI products will be communicated to you by the sales representative, or it is possible to check the availability of the country in the form for creating a shipment.",
  "consignment.import.dataFormat.collis":
    'It is possible to enter more items within one shipment. In a such case, items must be delimited: for xlsx format by delimiter of items as set in the form, for csv format by use of quotation marks around items information (e.g. {bold}1;1;1{bold};"carton;pallet;barrel";"medical supplies;concrete;bricks";;"31;30;99";"30;29;98";"29;28;97";"55;54;53"). Itemss are limited by single dimensions according to current business conditions.',
  "consignment.import.dataFormat.flag": "flag",
  "consignment.import.dataFormat.flagText":
    "In case of additional services, where only {flag} is entered, it is possible to enter values True (t), ano (a, yes or y). In case you fill in different value, service is not activated. ",
  "consignment.import.dataFormat.products":
    "Product code; possible values are ECD_B2C (Home Delivery Domestic), ECD_B2B (DHL Road Freight Standard Domestic (Euroconnect Domestic)), ECI (DHL Road Freight Standard International (Euroconnect International)), ECI_B2C (Home Delivery International), ERI (DHL Road Freight Priority International (Eurapid)), ERD (DHL Road Freight Priority Domestic (Eurapid)), ELD (DHL Road Freight Direct Domestic (Euroline Domestic)) and ELI (DHL Road Freight Direct International (Euroline International))",
  "consignment.import.dataFormat.reference":
    "Customer Reference; recommended to fill it in for better identification not only of the import result of the given shipment",
  "consignment.import.dataFormat.pickup.name": "Consignor name",
  "consignment.import.dataFormat.pickup.subname": "Consignor party name 2",
  "consignment.import.dataFormat.pickup.street": "Consignor street",
  "consignment.import.dataFormat.pickup.streetNumber":
    "Consignor street number/house number",
  "consignment.import.dataFormat.pickup.localDestination":
    "Specification of consingnor's address",
  "consignment.import.dataFormat.pickup.city": "Consignor city (locality)",
  "consignment.import.dataFormat.pickup.zipCode":
    "Consignor postal code; in destination country format (internal spaces will be deleted)",
  "consignment.import.dataFormat.pickup.country":
    "Consignor country; in two-digit (ISO 3166-1 Alpha-2) or three-digit (ISO 3166-1 Alpha-3) format",
  "consignment.import.dataFormat.pickup.contactPerson":
    "Consignor's contact person",
  "consignment.import.dataFormat.pickup.contactPhone":
    "Telephone contact to the consignor; valid format according to the given prefix, in case the prefix is not entered, the Czech (+420) is added; the prefix can be entered in the format + XX or 00XX or XX",
  "consignment.import.dataFormat.pickup.contactEmail":
    "Consignor's e-mail address; valid e-mail format required",
  "consignment.import.dataFormat.pickup.save":
    "Save consignor address as customer; flag; optional value; default value is False",
  "consignment.import.dataFormat.delivery.name": "Consignee party name",
  "consignment.import.dataFormat.delivery.subname": "Consignee party name 2",
  "consignment.import.dataFormat.delivery.street": "Consignee Street",
  "consignment.import.dataFormat.delivery.streetNumber":
    "Consignee street number/House number",
  "consignment.import.dataFormat.delivery.localDestination":
    "Specification of consingnee's address",
  "consignment.import.dataFormat.delivery.city": "Consignee city (locality)",
  "consignment.import.dataFormat.delivery.zipCode":
    "Consignee postal code; in destination country format (internal spaces will be deleted)",
  "consignment.import.dataFormat.delivery.country":
    "Consignee country; in two-digit  (ISO 3166-1 Alpha-2) or three digit (ISO 3166-1 Alpha-3) format",
  "consignment.import.dataFormat.delivery.contactPerson":
    "Consignee's contact person",
  "consignment.import.dataFormat.delivery.contactPhone":
    "Consignee's telephone number; valid format according to the given prefix, in case the prefix is not entered, the Czech (+420) is added; the prefix can be entered in the format + XX or 00XX or XX",
  "consignment.import.dataFormat.delivery.contactEmail":
    "Consignee's e-mail address; valid e-mail format required",
  "consignment.import.dataFormat.delivery.save":
    "Save consignee address as customer; flag; optional value; default value is True",
  "consignment.import.dataFormat.invoice.name": "Invoicee party name",
  "consignment.import.dataFormat.invoice.subname": "Invoicee party name 2",
  "consignment.import.dataFormat.invoice.street": "Invoicee street",
  "consignment.import.dataFormat.invoice.streetNumber":
    "Invoicee street number/House number",
  "consignment.import.dataFormat.invoice.localDestination": "Invoicee address",
  "consignment.import.dataFormat.invoice.city": "Invoicee city (locality)",
  "consignment.import.dataFormat.invoice.zipCode":
    "Invoicee postal code; in destination country format (internal spaces will be deleted)",
  "consignment.import.dataFormat.invoice.country":
    "Invoicee country; in two-digit  (ISO 3166-1 Alpha-2) or three digit (ISO 3166-1 Alpha-3) format",
  "consignment.import.dataFormat.invoice.contactPerson":
    "Invoicee contact person",
  "consignment.import.dataFormat.invoice.contactPhone":
    "Invoicee phone number; valid format according to the given prefix, in case the prefix is not entered, the Czech (+420) is added; the prefix can be entered in the format + XX or 00XX or XX",
  "consignment.import.dataFormat.invoice.contactEmail":
    "Invoicee e-mail; valid format is required",
  "consignment.import.dataFormat.invoice.save":
    "Save invoicee address as customer; flag; optional value; default value is False",
  "consignment.import.dataFormat.colli.count": "Number of colli",
  "consignment.import.dataFormat.colli.wrapping":
    "Packing of items; avalable values according shipment entering form",
  "consignment.import.dataFormat.colli.description": "Goods description",
  "consignment.import.dataFormat.colli.barcode":
    "Item code(s); necessary to enter in valid format; if you do not have your own number serie, or not sure with the format, code will be automatically added while sending data to DHL",
  "consignment.import.dataFormat.colli.height":
    "height/heights of single items; natural number limited by maximum value valid for the given product",
  "consignment.import.dataFormat.colli.width":
    "width/widths of single items; natural number limited by maximum value valid for the given product",
  "consignment.import.dataFormat.colli.length":
    "length/lengths of single items; natural number limited by maximum value valid for the given product",
  "consignment.import.dataFormat.colli.weight":
    "weight/weights of single items; natural number limited by maximum value valid for the given product",
  "consignment.import.dataFormat.colli.stackability":
    'stackability/stackabilities of single items; flag, for example for 3 pieces it is "a;n;a"',
  "consignment.import.dataFormat.services.codPrice":
    "C.O.D. amount; natural number",
  "consignment.import.dataFormat.services.codCurrency":
    "C.O.D. currency; in format ISO 4217; currently available in CZ (CZK), SK (EUR) and PL (PLN), default value is CZK",
  "consignment.import.dataFormat.services.codVariableSymbol":
    "C. O. D. variable symbol; only numbers; maximum length is 10 digits",
  "consignment.import.dataFormat.services.documentsBack":
    "Service Returned documents; flag; only for ECD_B2C and ECD_B2B products",
  "consignment.import.dataFormat.services.insurance":
    "Service Additional Insurance; flag",
  "consignment.import.dataFormat.services.peur":
    "Service Return of EUR pallets; natural number; only for ECD_B2C and ECD_B2B products",
  "consignment.import.dataFormat.services.adr":
    "Dangerous goods (ADR) information; in case that shipment is classified as ADR, please fill in following format: UN number, official name, class, packing group, quantity; only for ECD_B2C and ECD_B2B products",
  "consignment.import.dataFormat.services.cash":
    "Freight costs paid in cash; if the value is filled in, the amount for shipping is collected in cash, the input options are 1 (consignee) and 2 (consignor), only for ECD_B2C and ECD_B2B products",
  "consignment.import.dataFormat.services.pickupFront":
    "Tail-lift handling at pick up shipment; flag",
  "consignment.import.dataFormat.services.pickupCart":
    "Pallet jack handling at pick up shipment; flag",
  "consignment.import.dataFormat.services.deliveryFront":
    "Tail-lift handling at delivery shipment; flag",
  "consignment.import.dataFormat.services.deliveryCart":
    "Pallet jack handling at delivery shipment; flag",
  "consignment.import.dataFormat.services.lift":
    "Service Carry to the floor; flag; only for ECD_B2C product",
  "consignment.import.dataFormat.services.oldBack":
    "Service Removal of old appliances; flag; only for ECD_B2C product",
  "consignment.import.dataFormat.services.sms":
    "Sending a sms to the consignee; flag; in case field is not filled in, the value from the customer settings is added",
  "consignment.import.dataFormat.services.personalPickup":
    "Self delivery at DHL warehouse; in case of entering DHL warehouse code (in format PRG, OSR etc. - in accordance with available list of CZ DHL warehouses), self delivery to selected czech warehouse is expected",
  "consignment.import.dataFormat.services.personalDelivery":
    "Self-collection up at DHL warehouse; in case of entering DHL warehouse code (in format PRG, OSR etc. - in accordance with available list of CZ DHL warehouses), self-collection at selected czech warehouse is expected",
  "consignment.import.dataFormat.services.pod":
    "Proof of delivery; flag; only for ECI, ECI_B2C and ERI products",
  "consignment.import.dataFormat.services.iod":
    "Service Information of delivery (IOD); flag; only for ECI and ECI_B2C product",
  "consignment.import.dataFormat.services.extraInsurance":
    "Service Additional insurance of the shipment for 110% of the commercial value of the goods; flag; only for ECI and ECI_B2C product",
  "consignment.import.dataFormat.services.documents":
    "Service D.A.D. (Delivery Against Documents); flag; only for product ECI and ECI_B2C",
  "consignment.import.dataFormat.services.customs":
    "Service Customes clearance; flag; only for product ECI and ECI_B2C",
  "consignment.import.dataFormat.services.fdd":
    "FDD; flag, the date itself is entered in column 61, only for product ECI",
  "consignment.import.dataFormat.services.nationalTransportId":
    "EKAER (HU), SENT (PL), UIT (RO); if you wish to specify EKAER/SENT/UIT free, please enter 'N/A'; maximum length is 20, only for delivery to HU/PL/RO, only for product ECI, ECI_B2C and ERI",
  "consignment.import.dataFormat.services.nationalTransportIdFree":
    "EKAER free (HU), SENT free (PL), UIT free (RO); flag, only for delivery to HU/PL/RO, only for product ECI, ECI_B2C and ERI",
  "consignment.import.dataFormat.services.timeSlotBooking":
    "Time-slot booking; flag, only for product ECI, ECI_B2C, ERD and ERI",
  "consignment.import.dataFormat.services.preAdviseDelivery":
    "Pre-advise delivery; flag, only for product ECI, ECI_B2C, ERD and ERI",
  "consignment.import.dataFormat.services.incoterms":
    "Delivery term (Incoterms); list of values {link}; only for products ECI, ECI_B2C and ERI",
  "consignment.import.dataFormat.services.deliveryDate":
    "Start of delivery; in format d.m.yyyy (day, month, year), only for product ELI and ELD",
  "consignment.import.dataFormat.services.price":
    "Value of the goods; natural number",
  "consignment.import.dataFormat.services.priceCurrency":
    "Currency of value of the goods; in format ISO 4217; available currencies are CZK, PLN, USD, EUR; default value is CZK",
  "consignment.import.dataFormat.services.pickupDate":
    "(for ELI and ELD Start) Pick up date; in format d.m.yyyy (day, month, year); optional; if not specified, will be assigned automatically",
  "consignment.import.dataFormat.services.pickupDateTo":
    "End of pickup; in format d.m.yyyy (day, month, year), only for product ELI and ELD",
  "consignment.import.dataFormat.services.deliveryDateTo":
    "End of delivery; in format d.m.yyyy (day, month, year), only for product ELI and ELD",
  "consignment.import.dataFormat.services.free": "not used - for future use",
  "consignment.import.dataFormat.services.note": "Shipment note",
  "consignment.import.dataFormat.adr.unClass":
    "ADR - class; allowed values are 1.4, 2.1, 2.2, 3, 4.1, 5.1, 6.1, 8, 9",
  "consignment.import.dataFormat.adr.unCode":
    "ADR - UN number; in the format XXXX (3333)",
  "consignment.import.dataFormat.adr.chemicalName": "ADR - chemical name",
  "consignment.import.dataFormat.adr.packagingGroup":
    "ADR - packaging group; optional, allowed values are I, II, III",
  "consignment.import.dataFormat.adr.packagingType":
    "ADR - packaging type; allowed values are BBG, BS, CT, CYL, DR, CI, BX, BG, IBC",
  "consignment.import.dataFormat.adr.environmentalHazard":
    "ADR - environmental hazard; flag; optional",
  "consignment.import.dataFormat.adr.packagingDescription":
    "ADR - packaging description; optional, will be filled from packaging type",
  "consignment.import.dataFormat.adr.quantity":
    "ADR - quantity of ADR substance; decimal bigger than 0",
  "consignment.import.dataFormat.adr.quantityType":
    "ADR - quantity type; allowed values are 1 (limited quantity according to 3.4. LQ) or 2 (exemption limits according to 1.1.3.6.) or 3 (full - above-limit ADR) or 4 (excepted quantity according to 3.5. EQ) or 5 (Empty Packing)",
  "consignment.import.dataFormat.adr.handlingUnitsQuantity":
    "ADR - quantity of handling units; natural number",
  "consignment.import.dataFormat.adr.grossWeight":
    "ADR - gross weight; decimal bigger than 0",
  "consignment.services": "Services",
  "consignment.services.dateCheckError":
    "An error occured while checking the date",
  "consignment.services.dateCheck.country": "Choose pickup country please",
  "consignment.services.chooseCurrency": "Choose currency",
  "consignment.services.palletJack": "Pallet jack",
  "consignment.services.tailLift": "Tail-lift",
  "consignment.services.price": "Value of the goods",
  "consignment.services.emptyPrice": "Enter a value",
  "consignment.services.emptyInsurance":
    "Fee for additional insurance is {insurancePrice} {insuranceCurrency} considering shipment attributes.",
  "consignment.services.formLoadError":
    "An error occurred while loading the services available, please reload the form",
  "consignment.services.pickupDate": "Pick up date",
  "consignment.services.pickupRange": "Pick up date",
  "consignment.services.deliveryRange": "Delivery date",
  "consignment.services.emptyPickupRange": "Select pickup date!",
  "consignment.services.pickupHandling": "Pick up handling",
  "consignment.services.deliveryHandling": "Delivery handling",
  "consignment.services.notes": "Shipping notes",
  "consignment.services.incoterms": "Delivery term",
  "consignment.services.emptyIncoterms": "Choose delivery term",
  "consignment.services.incotermsError":
    "An error occurred while loading the delivery term. If you want to enter delivery term, please reload the form!",
  "consignment.services.deliveryDate": "Delivery date",
  "consignment.services.fdd": "FDD",
  "consignment.services.pod": "Print Information of Delivery (POD)",
  "consignment.services.iod": "Information of Delivery",
  "consignment.services.extraInsurance":
    "Additional Insurance of the shipment for 110% of the commercial value of the goods",
  "consignment.services.customsClearance": "Customs clearance",
  "consignment.services.deliveryAgainstDocuments":
    "Delivery Against Documents (D. A. D.)",
  "consignment.services.documentBack": "Documents to be returned",
  "consignment.services.sms": "SMS",
  "consignment.services.peur": "P-EUR to be returned",
  "consignment.services.peur.info":
    "If you do not wish to return pallets, please select 'Pallet' wrapping instead of 'P-EUR' for the corresponding loading units.",
  "consignment.services.peurCount": "Number of P-EUR",
  "consignment.services.emptyPeurCount": "Enter number of P-EUR",
  "consignment.services.peurMinCount":
    "The count of P-EUR must be greater than or equal to the count of items with P-EUR packaging!",
  "consignment.services.cashTransportPay": "Freight costs in cash",
  "consignment.services.payer": "Payer",
  "consignment.services.emptyPayer": "Choose payer",
  "consignment.services.consignor": "Consignor",
  "consignment.services.consignee": "Consignee",
  "consignment.services.otherAddress": "Another billing address",
  "consignment.services.transportOldAppliance":
    "Removal of an old device (appliance)",
  "consignment.services.carryToFloor":
    "Carry to the floor with the help of the consignee",
  "consignment.services.carryToFloorInfo":
    "In case of Carry to the floor service, maximum weight of the shipment is 80 kg and 50 kg of 1 item",
  "consignment.services.ekaer": "EKAER",
  "consignment.services.ekaer.empty": "Enter EKAER code, please",
  "consignment.services.ekaerFree": "EKAER free",
  "consignment.services.sent": "SENT",
  "consignment.services.sent.empty": "Enter SENT code, please",
  "consignment.services.sentFree": "SENT free",
  "consignment.services.uit": "UIT",
  "consignment.services.uit.empty": "Enter UIT code, please",
  "consignment.services.uitFree": "UIT free",
  "consignment.services.timeSlotBooking": "Time-slot booking",
  "consignment.services.preAdviseDelivery": "Pre-advise delivery",
  "consignment.services.emptyCodAmount": "Please enter C.O.D. amount",
  "consignment.services.emptyCodCurrencies":
    "You have no enabled C.O.D. currency",
  "consignment.services.variableSymbol": "Variable symbol",
  "consignment.services.emptyVariableSymbol": "Please enter variable symbol",
  "consignment.services.payByCreditCard": "Pay C.O.D. by credit card",
  "consignment.services.adr": "Dangerous goods (ADR)",
  "consignment.services.adrInfo":
    "Dangerous goods (ADR) information; in case that shipment is classified as ADR, please fill in following format: UN number, official name, class, packing group, quantity",
  "consignment.services.emptyAdrInfo": "Please provide information on ADR",
  "consignment.services.adr.info":
    "For the possibility of transporting ADR UN classes 1.4; 4.2; 4.3; 5.2; it is necessary to create an enquiry via the Customer Service at DHLFreight.cz@dhl.com",
  "consignment.services.adr.unClass": "Class",
  "consignment.services.adr.emptyUnClass": "Please provide class",
  "consignment.services.adr.unClassError":
    "An error occurred while loading the UN classes, please reload the form",
  "consignment.services.adr.unCode": "UN number",
  "consignment.services.adr.emptyUnCode": "Please provide UN number",
  "consignment.services.adr.chemicalName": "Chemical name",
  "consignment.services.adr.emptyChemicalName": "Please enter chemical name",
  "consignment.services.adr.packagingGroup": "Packing group",
  "consignment.services.adr.emptyPackagingGroup":
    "Please enter packaging group",
  "consignment.services.adr.packagingGroupError":
    "An error occurred while loading the packaging groups, please reload the form",
  "consignment.services.adr.packagingType": "Packing type",
  "consignment.services.adr.emptyPackagingType": "Please enter packaging type",
  "consignment.services.adr.packagingTypeError":
    "An error occurred while loading the packaging types, please reload the form",
  "consignment.services.adr.packagingDescription": "Packing description",
  "consignment.services.adr.emptyPackagingDescription":
    "Please enter packaging description",
  "consignment.services.adr.quantity": "Quantity of ADR substance",
  "consignment.services.adr.quantity.extended":
    "Total quantity of ADR substance",
  "consignment.services.adr.quantity.over":
    "The total quantity of ADR substance is greater than the maximum allowed.",
  "consignment.services.adr.quantity.over.grossWeight":
    "The total quantity of the ADR substance is greater than the gross weight of all ADR items.",
  "consignment.services.adr.emptyQuantity": "Please enter quantity",
  "consignment.services.adr.handlingUnitsQuantity": "Handling units quantity",
  "consignment.services.adr.handlingUnitsQuantity.over":
    "The total quantity of ADR handling units is greater than the maximum allowed.",
  "consignment.services.adr.emptyHandlingUnitsQuantity":
    "Please provide handling units quantity",
  "consignment.services.adr.grossWeight": "Gross weight",
  "consignment.services.adr.grossWeight.over":
    "The gross weight of all ADR items is greater than the maximum allowed.",
  "consignment.services.adr.emptyGrossWeight": "Please enter gross weight",
  "consignment.services.adr.grossWeight.summary": "Gross weight LQ",
  "consignment.services.adr.environmentalHazard": "Environmental hazard",
  "consignment.services.adr.environmentalHazard.empty":
    "Select one option please",
  "consignment.services.adr.quantityType": "Quantity type",
  "consignment.services.adr.limitedQuantity":
    "Limited quantity according to 3.4. LQ",
  "consignment.services.adr.exemptedQuantity":
    "Excepted quantity according to 3.5. EQ",
  "consignment.services.adr.emptyPackage": "Empty Packing",
  "consignment.services.adr.fullAdrQuantity": "Full - above-limit ADR",
  "consignment.services.adr.underLimitQuantity":
    "Exemption limits according to 1.1.3.6.",
  "consignment.services.adr.add": "Add ADR item",
  "consignment.services.adr.drop": "Drop ADR item",
  "consignment.product.loadError":
    "An error occured while loading the products",
  "consignment.product.chooseProduct": "Select a product to continue",
  "consignment.product.chosenProduct": "Your selected shipment product",
  "consignment.product.choose": "Choose shipment product",
  "consignment.product.cannotLoad": "Failed to load available products",
  "invoice.list": "List of invoices",
  "invoice.export": "Export invoices",
  "invoice.what": "invoices",
  "invoice.errorName": "invoice",
  "invoice.code": "Number",
  "invoice.codeFull": "Invoice number",
  "invoice.noInvoices": "No invoices available",
  "invoice.state": "Status",
  "invoice.paid": "Invoice paid",
  "invoice.canceled": "Invoice cancelled",
  "invoice.notPaid": "The invoice has not been paid yet",
  "invoice.creditNote": "Credit note",
  "invoice.notPaidAndAfterDueDate": "The invoice has not been paid yet",
  "invoice.invoiceType": "Type",
  "invoice.issueDate": "Issue date",
  "invoice.taxableDate": "Taxable on",
  "invoice.dueDate": "Due date",
  "invoice.payDate": "Date of payment",
  "invoice.daysAfterDueDate": "Overdue days",
  "invoice.amount": "Amount",
  "invoice.currency": "Currency",
  "invoice.afterPayDatee": "Overdue invoices only",
  "invoice.onlyNotPaidd": "Only unpaid invoices",
  "prints.zebraList": "Zebra labels",
  "prints.labelList": "List of labels",
  "prints.invoiceList": "List of invoices",
  "prints.addressList": "List of customers",
  "prints.addressList.noAddresses": "No customers to print",
  "prints.invoiceList.noInvoices": "No invoices to print",
  "prints.pages": "page {pageNumber} of {totalPages}",
  "prints.printedOn": "Printed: {dt}",
  import: "Import of new {what}",
  "import.format": "Template in {type} format",
  "import.message":
    "Please update your template, ADR attributes and items stackability have been added, thank you.",
  "import.download": "Click to download",
  "import.dataFormat": "Data format",
  "import.cancelLoading": "Loading was cancelled",
  "import.fileTypes": "Supported file types are csv and xlsx",
  "import.result": "Import result",
  "import.uploadAborted": "Loading was cancelled",
  "import.supportedFormats": "Supported file types are csv and xlsx.",
  "import.templateResult": "Template name: {templateName} (template nr.{row})",
  "import.referenceResult":
    "Shipment reference: {customerReference} (row {row})",
  "import.customerResult": "Customer {name} (row {row})",
  "import.entityResult": "{entity} on {row}",
  "import.success": "Import was successful",
  "import.error": "A problem occured while importing the {what}",
  "import.fileType": "File type",
  "import.containsHeader": "File contains a heading",
  "import.workbookNUmber": "Workbook number",
  "import.emptyWorkbookNUmber": "Please fill in workbook number",
  "import.filePassword": "File password",
  "import.colliDelimiter": "Item(s) attribute delimiter",
  "import.emptyColliDelimiter": "Please fill in items delimiter",
  "import.coding": "Coding",
  "import.emptyCoding": "Please choose file coding",
  "import.firstDelimiter": "semicolon",
  "import.delimiter": "Delimiter",
  "import.emptyDelimiter": "Please fill in delimiter",
  "import.uploadSuccess": "The {name} file was uploaded successfully.",
  "import.uploadError":
    "An error occurred while processing the file: {message}",
  "import.uploadErrorInfo":
    "Check if you use the latest version of template, there can be some new attributes",
  "import.uploadFailure": "Upload of {name} file failed.",
  "import.clickOrDrag": "Click or drag the file here",
  "export.pdf": "in pdf format",
  "export.xlsx": "in xlsx format",
  "export.error": "An error occured while creating export file.",
  "export.noEntitiesAll":
    "No {entity} selected, do you want to export all loaded {entity}?",
  "export.noEntities":
    "No {entity} selected, try changing the filter attributes.",
  tracking: "TRACK&TRACE",
  "tracking.error": "Error",
  "tracking.emptyCode":
    "Please enter the shipment number, item number or reference!",
  "tracking.placeholder": "enter the shipment number, item number or reference",
  "tracking.findNew": "Search new shipment",
  "tracking.serverError": "Sever is not available at the moment!",
  "tracking.yourConsignment": "YOUR SHIPMENT",
  "tracking.place": "Place",
  "tracking.dateTime": "Time",
  "tracking.message": "Status",
  "tracking.transportDetail": "Detail of transport",
  "tracking.actualState": "Current shipment status",
  "tracking.actualState.message": "Shipment status",
  "tracking.actualState.dateTime": "Place and Time",
  "tracking.information": "Shipment information",
  "tracking.consignment.code": "Shipment code",
  "tracking.consignment.orderCode": "Order code {orderCode}",
  "tracking.consignment.sender": "Consignor's location",
  "tracking.consignment.customerReference": "Customer Reference",
  "tracking.consignment.countOfCollis": "Number of colli",
  "tracking.consignment.weight": "Weight",
  "tracking.consignment.cashOnDelivery": "Cash On Delivery (C.O.D.)",
  notification: "Notification",
  "notification.list": "Notifications",
  "notification.new": "New notification",
  "notification.edit": "Edit notification",
  "notification.createNew": "Create new notification",
  "notification.unknown": "Unknown notification",
  "notification.name.def": "Notification",
  "notification.name": "Notification name",
  "notification.name.empty": "Enter notification name.",
  "notification.title.cz": "Title CZ",
  "notification.title.cz.empty": "Enter CZ title.",
  "notification.title.en": "Title EN",
  "notification.title.en.empty": "Enter EN title.",
  "notification.title.pl": "Title PL",
  "notification.title.pl.empty": "Enter PL title.",
  "notification.message.cz": "Content CZ",
  "notification.message.en": "Content EN",
  "notification.message.pl": "Content PL",
  "notification.message.empty": "Enter CZ and EN content!",
  "notification.insertionDateTime": "Creation date",
  "notification.errorName": "notification",
  "notification.notificationName": "Notification name",
  "notification.creator": "Notification creator",
  "notification.what": "notification",
  "notification.noNotifications": "no notifications",
  "notification.displayToUsers.filter": "Only displayed to users",
  "notification.displayToUsers": "Displayed to users",
  "notification.displayToUsers.yes": "Displayed to users",
  "notification.displayToUsers.no": "Hidden to users",
  "notification.validTo": "Display to",
  "notification.validTo.info":
    "The date and time until which this notification should be displayed to users.",
  "notification.validTo.to": " to {date}",
  "notification.changeDateTime": "Last edit",
  "notification.changer": "Notification editor",
  "notification.save.success": "Notification was successfully saved.",
  "notification.save.error": "An error occured while saving notification.",
  "notification.confirm": "Confirm reading",
  "notification.later": "Read later",
  "notification.read": "click to view unread notifications",
  "contracts.header": "Terms and Conditions and Contracts",
  "contracts.error":
    "An error occurred while loading the client data, please try again.",
  "contracts.terms": "Terms and Conditions and Registration",
  "contracts.terms.agree":
    "Consent to the terms and conditions is valid from {date}.",
  "contracts.terms.here": "current terms and conditions for printing",
  "contracts.terms.check":
    "I agree to the terms and conditions of DHL Freight CZ",
  "contracts.terms.check.contract":
    "The consent cannot be revoked due to the concluded contract.",
  "contracts.terms.check.no":
    "Consent has been withdrawn, it is not possible to send shipments to the DHL.",
  "contracts.terms.check.agree":
    "In case of withdrawal of consent, sending shipments to DHL will be blocked.",
  "contracts.terms.check.agree.no":
    "If agreed, shipments will be allowed to be sent to the DHL.",
  "contracts.terms.check.question":
    "If you withdraw your consent, sending shipments to the DHL will be blocked!",
  "contracts.terms.check.question.title":
    "Do you really wish to withdraw your consent to the terms and conditions?",
  "contracts.terms.check.question.success":
    "Consent to DHL Freight terms and conditions has been withdrawn!",
  "contracts.terms.check.question.error":
    "There was an error when removing consent, please try again!",
  "contracts.contract": "Contracts and pricelists",
  "contracts.contract.pricelist.ecd":
    "current general pricelist for ECD products",
  "contracts.contract.pricelist.eci":
    "current general pricelist for ECI products",
  "contracts.contract.no": "No contract is available.",
  "oneTimeLogin.list": "One time login",
  "oneTimeLogin.errorName": "one time login",
  "oneTimeLogin.new": "New login",
  "oneTimeLogin.new.long": "New one time login",
  "oneTimeLogin.new.title": "Create new one time login",
  "oneTimeLogin.save": "Create one time login",
  "oneTimeLogin.lastLogin": "Login date",
  "oneTimeLogin.used": "Login was used.",
  "oneTimeLogin.validity": "State",
  "oneTimeLogin.deleted": "Login was cancelled. Valid to {date}.",
  "oneTimeLogin.invalid": "One time login expired. Valid to {date}.",
  "oneTimeLogin.valid":
    "Valid to {date}, click to send the sms again and increase the login time.",
  "oneTimeLogin.inserter": "Creation",
  "oneTimeLogin.changer": "Edit",
  "oneTimeLogin.deleter": "Cancel",
  "oneTimeLogin.drop": "Click to cancel login",
  "oneTimeLogin.drop.success": "One time login was successfully cancelled.",
  "oneTimeLogin.drop.dropped": "Already cancelled.",
  "oneTimeLogin.drop.error": "An error occurred while trying to cancel!",
  "oneTimeLogin.resend.success": "The SMS was successfully resent.",
  "oneTimeLogin.resend.limit": "The sms sending limit has been exceeded.",
  "oneTimeLogin.resend.unknown": "Unknown login request.",
  "oneTimeLogin.resend.error": "An error occurred while trying to send an sms.",
  "oneTimeLogin.whom": "one time login",
  "oneTimeLogin.noUsers": "this client has no one time logins",
  "oneTimeLogin.phone": "Phone number",
  "oneTimeLogin.phone.empty": "Enter phone",
  "oneTimeLogin.code": "Code",
  "document.new": "New document",
  "document.edit": "Edit document",
  "document.load.error": "An error occured while loading document.",
  "document.current": "Current client",
  "document.clients": "List of clients",
  "document.clients.info":
    "please insert below a file with a unique client identifiers (Company ID, Tax ID, EVO Contract, ZAccount) separated by semicolon, comma or enter",
  "document.upload.button": "Upload attachments (max {max})",
  "document.upload.success":
    "Attachment {name} has been successfully uploaded.",
  "document.upload.response":
    "An error occurred while processing the attachment: {message}.",
  "document.upload.error": "Uploading attachment {name} failed.",
  "document.upload.exceed":
    "The maximum number of attachments is {max}, if you wish to upload more, delete the previous one.",
  "document.onlyTxt": "Only .txt files are allowed to be uploaded",
  "document.file": "File",
  "document.url": "Link",
  "document.name": "Document name for client",
  "document.name.client": "Name",
  "document.desc": "Document description",
  "document.type": "Document type",
  "document.type.miss": "Choose document type please",
  "document.type.error": "An error occured while loading documents",
  "document.TermsAndConditions": "Terms and Conditions",
  "document.PriceList": "Price list",
  "document.Others": "Others",
  "document.validFrom": "Valid from",
  "document.validTo": "Expression to",
  "document.url.validation": "Enter a valid URL starting with https.",
  "document.autoResult": "After the valid to date",
  "document.autoResult.confirm": "Automatically confirm",
  "document.autoResult.reject": "Automatically reject",
  "document.blockOnReject": "In case of rejection, block the client",
  "document.email": "Email notification",
  "document.email.info":
    "It is possible to enter multiple email addresses separated by semicolons.",
  "document.email.confirm": "Inform in case of confirm",
  "document.email.reject": "Inform in case of reject",
  "document.create.success": "Document was successfully created.",
  "document.create.badData": "Entered data are not correct.",
  "document.create.noClients": "No clients were loaded from the file",
  "document.create.notFoundClients": "Some clients were not found.",
  "document.create.fileError": "Unable to upload file, please try again.",
  "document.create.error": "An error occurred while creating a document",
  "document.list": "Documents",
  "document.notProcessed": "Documents to be processed",
  "document.processed": "Processed documents",
  "document.what": "documents",
  "document.notProcessed.noData": "You have no documents to process",
  "document.processed.noData": "You have no documents",
  "document.blockOnReject.true":
    "If you reject this document, your access to DHL Freight CZ services will be blocked.",
  "document.blockOnReject.false": "Document to be processed",
  "document.inserter": "Submitted by",
  "document.result": "Response",
  "document.confirmed": "Document was confirmed.",
  "document.rejected": "Document was rejected.",
  "document.confirm": "Click to accept the document",
  "document.reject": "Click to reject the document",
  "document.resolve.success": "The document was processed successfully.",
  "document.resolve.error": "An error occurred while processing the document.",
  "document.resolve.logout":
    "Your account has been blocked due to rejection of an important DHL document.",
  "document.download": "Click to download document",
  "document.link.title": "Click to view document",
  "document.confirm.role":
    "You do not have the option to edit the document in your current role",
  "document.validTo.approve":
    "After this date, the document will be automatically approved.",
  "document.validTo.reject":
    "After this date, the document will be automatically rejected.",
  "document.read": "you have documents to process",
  "document.read.info": "You have documents to process. {second}",
  "document.read.info.user":
    "Please inform users with the administrator role about this fact.",
  "document.read.info.admin":
    "For processing, go to the document section in the left menu.",
  "document.clients.notFound": "Not found clients: {clients}",
  "document.drop": "Unassign a document for this client",
  "document.drop.success":
    "The document was successfully canceled for the current client.",
  "document.drop.error": "An error occurred while canceling the document.",
};
